import Vue from 'vue';
import Vuex from 'vuex';
import { map } from 'lodash';

import Dashboard from '@/scripts/Dashboard/Dashboard.store';
import Login from '@/scripts/Login/Login.store';
import LoginPhone from '@/scripts/LoginPhone/LoginPhone.store';
import Password from '@/scripts/Password/Password.store';
import MainModeCourse from '@/scripts/MainMode/MainModeCourse/MainModeCourse.store';
import MiniModeCourse from '@/scripts/MiniMode/MiniModeCourse/MiniModeCourse.store';
import FreeModeCourse from '@/scripts/FreeMode/FreeModeCourse/FreeModeCourse.store';
import PureModeCourse from '@/scripts/PureMode/PureModeCourse/PureModeCourse.store';
import LiveModeCourse from '@/scripts/LiveMode/LiveModeCourse/LiveModeCourse.store';
import TrailModeCourse from '@/scripts/TrailMode/TrailModeCourse/TrailModeCourse.store';
import MainModeBook from '@/scripts/MainMode/MainModeBook/MainModeBook.store';
import MiniModeBook from '@/scripts/MiniMode/MiniModeBook/MiniModeBook.store';
import FreeModeBook from '@/scripts/FreeMode/FreeModeBook/FreeModeBook.store';
import ReaderModeBook from '@/scripts/FreeMode/ReaderModeBook/ReaderModeBook.store';
import PureModeBook from '@/scripts/PureMode/PureModeBook/PureModeBook.store';
import TrailModeBook from '@/scripts/TrailMode/TrailModeBook/TrailModeBook.store';
import QA from '@/scripts/QA/QA.store';
import Mall from '@/scripts/Mall/Mall.store';
import Achievements from '@/scripts/Achievements/Achievements.store';
//import Reader from '@/scripts/Reader/Reader.store';
import Notes from '@/scripts/Notes/Notes.store';
import Message from '@/scripts/Message/Message.store';
import Exercise from '@/scripts/Exercise/Exercise.store';
import Events from '@/scripts/Events/Events.store';
import Identity from '@/scripts/Identity/Identity.store';
import Bookmark from '@/scripts/Bookmark/Bookmark.store';
import Setting from '@/scripts/Setting/Setting.store';
import Referral from '@/scripts/Referral/Referral.store';
import Points from '@/scripts/Points/Points.store';
import Transcript from '@/scripts/Activity/Transcript/Transcript.store';
import AllCourses from '@/scripts/AllCourses/AllCourses.store';
import Coupon from '@/scripts/Coupon/Coupon.store';
import FlashCard from '@/scripts/FlashCard/FlashCard.store';
import TrainingCamp from '@/scripts/TrainingCamp/TrainingCamp.store';
import Alumni from '@/scripts/Alumni/Alumni.store';
import Agreement from '@/scripts/Agreement/Agreement.store';
import AI from '@/scripts/AI/AI.store';
import Career from '@/scripts/Career/Career.store';
import PlvLiveRedirect from '@/scripts/PlvLiveRedirect/PlvLiveRedirect.store';
import PlvLiveLogin from '@/scripts/PlvLiveLogin/PlvLiveLogin.store';

import Mixins from '@/mixins/Mixins.store';

// import IMTeamAnnouncement from '@/scripts/IMTeamAnnouncement/IMTeamAnnouncement.store';

import * as service from './service';
import { getIsMobile, getIsWechatBrowser, getIsIosSafari, getIsInIframe } from '@/utils/browser';
import {
  GET_USER_INFO_SUCCESS,
  GET_TUTOR_INFO_SUCCESS,
  UPDATE_USER_INFO_SUCCESS,
  UPDATE_USER_INFO_PROFILE_SUCCESS,
  SET_IS_GET_ISLOGIN,
  NEED_ID_CHECK_SUCCESS,
  UPDATE_LOADING_STATUS,
  UPDATE_IMM_LOADING_STATUS,
  USER_INFO,
  TUTOR_INFO,
  PZCOOKIESESSION,
  UPDATE_ERROR_MESSAGE,
  UPDATE_AOP_LOADING_STATUS,
  LOGOUT_USER_SUCCESS,
  LOGOUT_NO_CHANGE_STORE_USER_SUCCESS,
  AFTER_LOGIN_COMPLETE,
  //importantMessage
  GET_IMPORTANT_MESSAGE_SUCCESS,
  READ_IMPORTANT_MESSAGE_SUCCESS,
  GET_GENERATE_BOOK_ALL_FILE_SUCCESS,
  SET_IS_DEBUG,
  SET_PZ_TEST,
  DUMMY_MUTATION,
  GET_VISITOR_ID_SUCCESS,
  GET_IM_TEAM_ANNOUNCEMENT_SUCCESS,
  SET_GOTO_LAST_STUDY,
  SET_CURRENT_SERVER_TIME,
  GET_VERSION,
  //CURRENT_VERSION,
  // POST_CHECK_CAPTCAH,
} from '../constants';
import {
  //getItem,
  setItemUserInfo,
  getItemUserInfo,
  removeItem,
  removeItemUserInfo,
  getLocalStorageItem,
  setLocalStorageItem,
} from '../global/storage';
//import { GET_VISITOR_ID } from '../constants/api';

Vue.use(Vuex);

const createDefaultUserInfo = () => ({
  unLogin: true,
  authenticated: -1,
  hasNewMessages: false,
  gender: 0,
  hasBindEmail: false,
  learningCourseCount: 0,
  completedDuration: 0,
  totalAandC: 0,
  myCourses: [],
  studentId: 0,
  showOldVersion: false,
  teacher: false,
  defaultSpeed: 1,
  hasBindWechat: false,
  nickname: '游客',
  studentIdText: '000000',
  email: '',
  registerDate: 0,
  passportNo: '',
  mobile: '',
  wechat: '',
  hasPay: false,
  isCurrentStudent: false,
  avatar: '/img/photos/avatar_955.png',
  bonusPoint: 0,
  referalCode: '',
  totalDays: 0,
  username: '游客',
  hasImportantMessages: false,
  profile: {
    studentId: 0,
    videoSpeed: 1,
    lastupdatedTime: 0,
    createdTime: 0,
    autoRemoveWronglist: false,
    questionFontSize: 1,
    questionLanguage: null,
    turnOnVoice: false,
    turnOnContinuous: false,
    identificationStatus: 0,
  },
});

export const store = new Vuex.Store({
  state: {
    userInfo: getItemUserInfo(USER_INFO) || createDefaultUserInfo(),
    isHaveGotUserInfo: false,
    tutorinfo: getLocalStorageItem(TUTOR_INFO),
    isGetIsLogin: false,
    res_getNeedIdCheck: false,
    afterLoginComplete: false,
    loading: false,
    immLoading: false,
    aopLoading: false,
    pzError: {},
    browserInfo: {
      isMobile: getIsMobile(),
      isWechatBrowser: getIsWechatBrowser(),
      isIosSafari: getIsIosSafari(),
    },
    isInCnIframe: getIsInIframe(),
    importantMessage: {
      count: 0,
      list: [],
    },
    bookAllFilePath: '',
    isDebug: getLocalStorageItem('isDebug'),
    pztest: window.sessionStorage.getItem('pztest'),
    visitorId: '',
    imTeamAnnouncementList: null,
    isSetGotoLastStudy: false,
    currentServerTime: new Date().getTime(),
    version: '',
  },

  getters: {
    userInfo: (state) => state.userInfo,
    tutorinfo: (state) => state.tutorinfo,
    identificationStatus: (state, getters) => getters.userInfo.profile.identificationStatus,
    res_getNeedIdCheck: (state) => state.res_getNeedIdCheck,
    visitorId: (state) => state.visitorId,
    loading: (state) => state.loading,
    immLoading: (state) => state.immLoading,
    aopLoading: (state) => state.aopLoading,
    pzError: (state) => state.pzError,
    isErrorHideLoading: (state) => 401 === state.pzError.code || 403 === state.pzError.code,
    afterLoginComplete: (state) => state.afterLoginComplete,
    //importantMessage
    importantMessageCount: (state) => state.importantMessage.count,
    importantMessageList: (state) => state.importantMessage.list,
    imTeamAnnouncementList: (state) => state.imTeamAnnouncementList,
    version: (state) => state.version,
  },

  mutations: {
    [GET_IM_TEAM_ANNOUNCEMENT_SUCCESS](state, data) {
      // state.isRequest = data;
      state.imTeamAnnouncementList = data;
      // console.log(data);
    },

    [GET_USER_INFO_SUCCESS](state, userInfo) {
      state.userInfo = { ...userInfo, unLogin: false };
      state.isHaveGotUserInfo = true;
      setItemUserInfo(USER_INFO, state.userInfo);
    },

    [UPDATE_USER_INFO_SUCCESS](state, payload) {
      state.userInfo = {
        ...state.userInfo,
        ...payload,
      };
      setItemUserInfo(USER_INFO, state.userInfo);
    },

    [UPDATE_USER_INFO_PROFILE_SUCCESS](state, payload) {
      state.userInfo = {
        ...state.userInfo,
        profile: {
          ...state.userInfo.profile,
          ...payload,
        },
      };
      setItemUserInfo(USER_INFO, state.userInfo);
    },

    [SET_IS_GET_ISLOGIN](state, isGetIsLogin) {
      state.isGetIsLogin = isGetIsLogin;
    },

    [GET_TUTOR_INFO_SUCCESS](state, tutorinfo) {
      state.tutorinfo = tutorinfo;
      setLocalStorageItem(TUTOR_INFO, state.tutorinfo);
    },

    // [POST_CHECK_CAPTCAH](state, ret) {
    //   state.ret = ret;
    // },

    [NEED_ID_CHECK_SUCCESS](state, res_getNeedIdCheck) {
      state.res_getNeedIdCheck = res_getNeedIdCheck;
    },

    [UPDATE_LOADING_STATUS](state, status) {
      state.loading = status;
    },

    [UPDATE_AOP_LOADING_STATUS](state, status) {
      state.aopLoading = status;
    },

    [UPDATE_IMM_LOADING_STATUS](state, status) {
      state.immLoading = status;
    },

    [UPDATE_ERROR_MESSAGE](state, error) {
      if (error.code === 401 || error.code === 403) {
        state.userInfo = createDefaultUserInfo();
        removeItemUserInfo(USER_INFO);
        removeItem(PZCOOKIESESSION);
      }
      state.pzError = error;
    },

    [LOGOUT_USER_SUCCESS](state) {
      state.userInfo = createDefaultUserInfo();
      state.importantMessage = {
        count: 0,
        list: [],
      };
      state.afterLoginComplete = false;
      state.pzError = {};
      removeItemUserInfo(USER_INFO);
      removeItem(PZCOOKIESESSION);
      removeItem('uid');
      removeItem('sdktoken');
    },

    [LOGOUT_NO_CHANGE_STORE_USER_SUCCESS]() {
      removeItemUserInfo(USER_INFO);
      removeItem(PZCOOKIESESSION);
    },

    [AFTER_LOGIN_COMPLETE](state) {
      state.afterLoginComplete = true;
    },

    //importantMessage
    [GET_IMPORTANT_MESSAGE_SUCCESS](state, importantMessage) {
      if (undefined !== importantMessage && null !== importantMessage) {
        state.importantMessage = importantMessage;
      }
    },

    //importantMessage
    [READ_IMPORTANT_MESSAGE_SUCCESS](state, payload) {
      const { messageId } = payload;
      state.importantMessage = {
        ...state.importantMessage,
        list: map(state.importantMessage.list, (message) => {
          if (messageId === message.messageId) {
            return {
              ...message,
              isCheck: true,
            };
          } else {
            return message;
          }
        }),
      };
    },

    [GET_GENERATE_BOOK_ALL_FILE_SUCCESS](state, bookAllFilePath) {
      if (undefined !== bookAllFilePath && null !== bookAllFilePath) {
        state.bookAllFilePath = bookAllFilePath;
      }
    },

    [SET_IS_DEBUG](state, isDebug) {
      if (undefined !== isDebug && null !== isDebug) {
        state.isDebug = isDebug;
      }
    },

    [SET_PZ_TEST](state, pztest) {
      if (undefined !== pztest && null !== pztest) {
        state.pztest = pztest;
      }
    },

    [DUMMY_MUTATION]() { },

    [GET_VISITOR_ID_SUCCESS](state, visitorId) {
      state.visitorId = visitorId;
    },

    [SET_GOTO_LAST_STUDY](state, isSetGotoLastStudy) {
      state.isSetGotoLastStudy = isSetGotoLastStudy;
    },

    [SET_CURRENT_SERVER_TIME](state, currentServerTime) {
      state.currentServerTime = currentServerTime;
      setCurrentServerTime();
    },
    [GET_VERSION](state, version) {
      state.version = version;
    },
  },

  actions: {
    clearModuleState({ commit }) {
      commit('MainModeCourse/CLEAR_STATE');
    },

    async getUserInfo({ commit /* , dispatch */ }, payload) {
      const res = await service.getUserInfo(payload);
      commit(GET_USER_INFO_SUCCESS, res.data.data);
      //dispatch('clearModuleState');
    },

    async updateProfile({ commit, state }, payload) {
      await service.updateProfile(payload);
      commit(UPDATE_USER_INFO_SUCCESS, { profile: { ...state.userInfo.profile, ...payload } });
    },

    getUserInfoFromData({ commit }, payload) {
      commit(GET_USER_INFO_SUCCESS, payload);
    },

    updateUserInfo({ commit }, payload) {
      commit(UPDATE_USER_INFO_SUCCESS, payload);
    },

    async getNeedIdCheck({ commit }, payload) {
      const res = await service.getNeedIdCheck(payload);
      commit(NEED_ID_CHECK_SUCCESS, res.data.data);
    },

    async logout({ commit }) {
      await service.logout();
      //commit(LOGOUT_NO_CHANGE_STORE_USER_SUCCESS);
      commit(LOGOUT_USER_SUCCESS);
    },

    logoutFromData({ commit }) {
      commit(LOGOUT_USER_SUCCESS);
    },

    afterLoginComplete({ commit }) {
      commit(AFTER_LOGIN_COMPLETE);
    },

    async getTutorInfo({ commit }) {
      const res = await service.getTutorInfo();
      commit(GET_TUTOR_INFO_SUCCESS, res.data.data);
    },

    async saveVendorId({ commit }, payload) {
      await service.saveVendorId(payload);
      commit(DUMMY_MUTATION);
    },

    // eslint-disable-next-line no-empty-pattern
    async eventTracker({ }, payload) {
      await service.eventTracker(payload);
    },

    async getVisitorId({ commit }) {
      const res = await service.getVisitorId();
      commit(GET_VISITOR_ID_SUCCESS, res.data.data);
    },

    async mallSmsRegisterV2({ commit }, payload) {
      await service.mallSmsRegisterV2(payload);
      commit(DUMMY_MUTATION);
    },

    //importantMessage
    async getImportantMessage({ commit }) {
      const res = await service.getImportantMessage();
      if (200 === res.data.status) {
        commit(GET_IMPORTANT_MESSAGE_SUCCESS, res.data.data);
      }
    },

    //importantMessage
    async readImportantMessage({ commit }, payload) {
      const res = await service.readImportantMessage(payload);
      if (200 === res.data.status) {
        commit(READ_IMPORTANT_MESSAGE_SUCCESS, payload);
      }
    },

    // eslint-disable-next-line no-empty-pattern
    // async trackingVendor({}, payload) {
    //   await service.trackingVendor(payload);
    // },

    async generateBookAllFile({ commit }, payload) {
      if (payload.isClear) {
        commit(GET_GENERATE_BOOK_ALL_FILE_SUCCESS, '');
        return;
      }
      const res = await service.generateBookAllFile(payload);
      if (200 === res.data.status) {
        commit(GET_GENERATE_BOOK_ALL_FILE_SUCCESS, res.data.data);
      }
    },

    async getIMTeamAnnouncementByTeamId({ commit }, payload) {
      const res = await service.getIMTeamAnnouncementByTeamId(payload);
      commit(GET_IM_TEAM_ANNOUNCEMENT_SUCCESS, res.data.data);
    },

    async getVersion({ commit }) {
      const res = await service.getVersion();
      commit(GET_VERSION, res.data.data.version);
    },
  },

  modules: {
    MainModeBook,
    MiniModeBook,
    FreeModeBook,
    ReaderModeBook,
    PureModeBook,
    PureModeCourse,
    LiveModeCourse,
    TrailModeBook,
    Dashboard,
    Events,
    Exercise,
    Identity,
    Login,
    LoginPhone,
    Password,
    MainModeCourse,
    MiniModeCourse,
    FreeModeCourse,
    TrailModeCourse,
    QA,
    Mall,
    Achievements,
    //Reader,
    Notes,
    Message,
    Setting,
    Referral,
    Points,
    Transcript,
    Bookmark,
    AllCourses,
    Coupon,
    FlashCard,
    TrainingCamp,
    Alumni,
    Agreement,
    AI,
    Career,
    PlvLiveRedirect,
    PlvLiveLogin,
    Mixins,
    // IMTeamAnnouncement,
  },
});

let itvlSetCurrentServerTime;
const setCurrentServerTime = () => {
  clearInterval(itvlSetCurrentServerTime);
  itvlSetCurrentServerTime = setInterval(() => {
    store.commit(SET_CURRENT_SERVER_TIME, store.state.currentServerTime + 1000);
  }, 1000);
};

export default store;
